// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.total-orders__content-wrapper {
	background-color: white;
	min-height: calc(100vh - 1px);
	display: flex;
	flex-direction: column;
	padding: 30px 24px 24px 0;
}

.total-orders__content {
	display: flex;
	flex-direction: column;
}

.total-orders__tab-selector {
	display: flex;
}

.total-orders__tab-item {
	height: 54px;
	border-radius: 10px 10px 0 0;
	font-size: 16px;
	line-height: 20px;
	padding: 0 40px;
	display: flex;
	align-items: center;
	cursor: pointer;
	font-weight: 500;
}

.total-orders__tab-item.active-tab {
	background-color: #f2f2f2;
}

.total-orders_page-main-content {
	background-color: #f2f2f2;
	padding: 24px;
	border-radius: 0 10px 10px 10px;
	display: flex;
	flex-direction: column;
	gap: 24px;
}

.total-orders__charts-container {
	display: flex;
	flex-direction: row;
	gap: 24px;
}

.total-orders__line-chart-block {
	padding: 20px;
	background: #ffffff;
	border-radius: 10px;
	display: flex;
	flex-direction: row;
	gap: 24px;
	max-height: 450px;
	width: calc(100% - 304px);
}

.total-orders__product-categories {
	width: 100%;
	background-color: #4db8ff;
	border-radius: 10px;
	padding: 24px;
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 280px;
	max-height: 450px;
}

.total-order__product-categories-items-wrapper {
	display: flex;
	flex-direction: column;
	gap: 8px;
	max-height: calc(450px - 80px);
	overflow-y: auto;
}

.total-order__product-categories-title {
	font-size: 20px;
	line-height: 24px;
	color: #ffffff;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
}

.total-order__product-categories-item {
	position: relative;
	min-height: 40px;
	border-radius: 8px;
	border: 1px solid white;
	display: flex;
	align-items: center;
	padding: 0 16px;
	overflow: hidden;
}

.total-order__product-categories-item-percentage {
	position: absolute;
	left: 0;
	z-index: 0;
	height: 100%;
	background-color: #ffffff;
}

.total-order__product-categories-item-label {
	font-size: 16px;
	line-height: 20px;
	color: #000000;
	z-index: 1;
	display: block;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.total-orders__line-chart {
	display: flex;
	width: calc(100% - 240px);
	flex-direction: column;
	gap: 8px;
}

.total-orders__line-chart-info {
	display: flex;
	flex-direction: column;
	gap: 24px;
	min-width: 223px;
}

.total-order__line-chart-title {
	font-size: 24px;
	line-height: 30px;
	font-weight: 600;
}

.total-orders__filter {
	border: 1px solid #e6e6e6;
	padding: 0 16px;
	height: 56px;
	width: fit-content;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	border-radius: 10px;
	width: 100%;
	transition: 0.3s;
}

.total-orders__selected-filter {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
}

.total-orders__chart-identifiers {
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding-left: 8px;
}

.total-orders__chart-identifier {
	display: flex;
	align-items: center;
	gap: 8px;
}

.total-orders__chart-color {
	width: 10px;
	height: 10px;
	border-radius: 50%;
}

.total-orders__chart-color.black {
	background-color: #191919;
}

.total-orders__chart-color.grey {
	background-color: #e6e6e6;
}

.total-orders__chart-color.blue {
	background-color: #4db8ff;
}

.total-orders__chart-title {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
}

.total-orders__products-stats {
	display: flex;
	flex-direction: row;
	gap: 24px;
}

.total-orders__products-stats-item {
	width: 100%;
	background-color: #ffffff;
	height: 178px;
	display: flex;
	flex-direction: column;
	padding: 24px;
	border-radius: 10px;
	gap: 20px;
}

.total-orders__products-stats-item-amount {
	font-size: 64px;
	line-height: 72px;
	font-weight: 600;
	color: #191919;
}

.total-orders__products-stats-item-title {
	font-size: 20px;
	line-height: 25px;
	font-weight: 500;
	color: #666666;
}

.total-order__dropdown-menu {
	width: 100%;
	border: 1px solid #e6e6e6;
	padding: 8px;
}

.total-order__dropdown-menu-wrapper {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.total-order__dropdown-menu-item {
	height: 39px;
	border-radius: 6px;
	padding: 0 10px;
	display: flex;
	align-items: center;
	color: #666666 !important;
	font-size: 16px;
	line-height: 20px;
}

.total-order__dropdown-menu-item:hover {
	background-color: #f2f2f2 !important;
}

.total-orders_dropdown-toggle.show .total-orders__filter .arrow-icon {
	transform: rotate(180deg);
	transition: 0.3s;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Dashboard/TotalOrders/TotalOrders.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,4BAA4B;CAC5B,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,+BAA+B;CAC/B,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,UAAU;CACV,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,UAAU;CACV,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,QAAQ;CACR,mBAAmB;CACnB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB","sourcesContent":[".total-orders__content-wrapper {\n\tbackground-color: white;\n\tmin-height: calc(100vh - 1px);\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 30px 24px 24px 0;\n}\n\n.total-orders__content {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.total-orders__tab-selector {\n\tdisplay: flex;\n}\n\n.total-orders__tab-item {\n\theight: 54px;\n\tborder-radius: 10px 10px 0 0;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tpadding: 0 40px;\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\tfont-weight: 500;\n}\n\n.total-orders__tab-item.active-tab {\n\tbackground-color: #f2f2f2;\n}\n\n.total-orders_page-main-content {\n\tbackground-color: #f2f2f2;\n\tpadding: 24px;\n\tborder-radius: 0 10px 10px 10px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n}\n\n.total-orders__charts-container {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 24px;\n}\n\n.total-orders__line-chart-block {\n\tpadding: 20px;\n\tbackground: #ffffff;\n\tborder-radius: 10px;\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 24px;\n\tmax-height: 450px;\n\twidth: calc(100% - 304px);\n}\n\n.total-orders__product-categories {\n\twidth: 100%;\n\tbackground-color: #4db8ff;\n\tborder-radius: 10px;\n\tpadding: 24px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n\twidth: 280px;\n\tmax-height: 450px;\n}\n\n.total-order__product-categories-items-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n\tmax-height: calc(450px - 80px);\n\toverflow-y: auto;\n}\n\n.total-order__product-categories-title {\n\tfont-size: 20px;\n\tline-height: 24px;\n\tcolor: #ffffff;\n\tfont-weight: 500;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 8px;\n}\n\n.total-order__product-categories-item {\n\tposition: relative;\n\tmin-height: 40px;\n\tborder-radius: 8px;\n\tborder: 1px solid white;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 16px;\n\toverflow: hidden;\n}\n\n.total-order__product-categories-item-percentage {\n\tposition: absolute;\n\tleft: 0;\n\tz-index: 0;\n\theight: 100%;\n\tbackground-color: #ffffff;\n}\n\n.total-order__product-categories-item-label {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #000000;\n\tz-index: 1;\n\tdisplay: block;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n}\n\n.total-orders__line-chart {\n\tdisplay: flex;\n\twidth: calc(100% - 240px);\n\tflex-direction: column;\n\tgap: 8px;\n}\n\n.total-orders__line-chart-info {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n\tmin-width: 223px;\n}\n\n.total-order__line-chart-title {\n\tfont-size: 24px;\n\tline-height: 30px;\n\tfont-weight: 600;\n}\n\n.total-orders__filter {\n\tborder: 1px solid #e6e6e6;\n\tpadding: 0 16px;\n\theight: 56px;\n\twidth: fit-content;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 8px;\n\tborder-radius: 10px;\n\twidth: 100%;\n\ttransition: 0.3s;\n}\n\n.total-orders__selected-filter {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n}\n\n.total-orders__chart-identifiers {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n\tpadding-left: 8px;\n}\n\n.total-orders__chart-identifier {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.total-orders__chart-color {\n\twidth: 10px;\n\theight: 10px;\n\tborder-radius: 50%;\n}\n\n.total-orders__chart-color.black {\n\tbackground-color: #191919;\n}\n\n.total-orders__chart-color.grey {\n\tbackground-color: #e6e6e6;\n}\n\n.total-orders__chart-color.blue {\n\tbackground-color: #4db8ff;\n}\n\n.total-orders__chart-title {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n}\n\n.total-orders__products-stats {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 24px;\n}\n\n.total-orders__products-stats-item {\n\twidth: 100%;\n\tbackground-color: #ffffff;\n\theight: 178px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 24px;\n\tborder-radius: 10px;\n\tgap: 20px;\n}\n\n.total-orders__products-stats-item-amount {\n\tfont-size: 64px;\n\tline-height: 72px;\n\tfont-weight: 600;\n\tcolor: #191919;\n}\n\n.total-orders__products-stats-item-title {\n\tfont-size: 20px;\n\tline-height: 25px;\n\tfont-weight: 500;\n\tcolor: #666666;\n}\n\n.total-order__dropdown-menu {\n\twidth: 100%;\n\tborder: 1px solid #e6e6e6;\n\tpadding: 8px;\n}\n\n.total-order__dropdown-menu-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n}\n\n.total-order__dropdown-menu-item {\n\theight: 39px;\n\tborder-radius: 6px;\n\tpadding: 0 10px;\n\tdisplay: flex;\n\talign-items: center;\n\tcolor: #666666 !important;\n\tfont-size: 16px;\n\tline-height: 20px;\n}\n\n.total-order__dropdown-menu-item:hover {\n\tbackground-color: #f2f2f2 !important;\n}\n\n.total-orders_dropdown-toggle.show .total-orders__filter .arrow-icon {\n\ttransform: rotate(180deg);\n\ttransition: 0.3s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
